<!--  -->
<template>
  <div class="centers">
    <div class="green">学生信息工作台</div>
    <div
      class="divs"
      :class="{ bgcolor: avtive == 1 }"
      @click="tiaos(1)"
      @mouseover="mousein(1)"
      @mouseleave="mouseout(1)"
    >
      <img
        v-if="avtive == 1 || imgpan == 1"
        src="../assets/register备份.png"
        alt=""
      />
      <img v-else src="../assets/register.png" alt="" />
      学生信息登记
    </div>
    <div
      class="divs"
      :class="{ bgcolor: avtive == 2 }"
      @click="tiaos(2)"
      @mouseover="mousein(2)"
      @mouseleave="mouseout(2)"
    >
      <img
        v-if="avtive == 2 || imgpan == 2"
        src="../assets/chaxun-4备份.png"
        alt=""
      />
      <img v-else src="../assets/chaxun-4.png" alt="" />
      登记结果查询
    </div>
    <div
      class="divs"
      :class="{ bgcolor: avtive == 3 }"
      @click="tiaos(3)"
      @mouseover="mousein(3)"
      @mouseleave="mouseout(3)"
    >
      <img
        v-if="avtive == 3 || imgpan == 3"
        src="../assets/wj-cj备份.png"
        alt=""
      />
      <img v-else src="../assets/wj-cj.png" alt="" />
      考生成绩查询
    </div>
    <div
      class="divs"
      :class="{ bgcolor: avtive == 4 }"
      @click="tiaos(4)"
      @mouseover="mousein(4)"
      @mouseleave="mouseout(4)"
    >
      <img
        v-if="avtive == 4 || imgpan == 4"
        src="../assets/xiugai-3备份.png"
        alt=""
      />
      <img v-else src="../assets/xiugai-3.png" alt="" />
      高中志愿填报
    </div>
    <div
      class="divs"
      :class="{ bgcolor: avtive == 5 }"
      @click="tiaos(5)"
      @mouseover="mousein(5)"
      @mouseleave="mouseout(5)"
    >
      <img
        v-if="avtive == 5 || imgpan == 5"
        src="../assets/luqutongzhishu备份.png"
        alt=""
      />
      <img v-else src="../assets/luqutongzhishu.png" alt="" />
      高中录取查询
    </div>
    <div
      class="divs"
      :class="{ bgcolor: avtive == 6 }"
      @click="tiaos(6)"
      @mouseover="mousein(6)"
      @mouseleave="mouseout(6)"
    >
      <img
        v-if="avtive == 6 || imgpan == 6"
        src="../assets/zaixianbaoming备份.png"
        alt=""
      />
      <img v-else src="../assets/zaixianbaoming.png" alt="" />
      中职学校报名
    </div>
    <div
      class="divs"
      :class="{ bgcolor: avtive == 7 }"
      @click="tiaos(7)"
      @mouseover="mousein(7)"
      @mouseleave="mouseout(7)"
    >
      <img
        v-if="avtive == 7 || imgpan == 7"
        src="../assets/chaxun备份.png"
        alt=""
      />
      <img v-else src="../assets/chaxun.png" alt="" />
      中职录取查询
    </div>
    <el-dialog title="温馨提示" :visible.sync="show" width="30%" center>
      <span>未到开放时间！</span>
      <span slot="footer" class="dialog-footer">
        <div class="queding" @click="show = false">确定</div>
      </span>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="njshow" width="30%" center>
      <span>该功能不对8年级考生开放！</span>
      <span slot="footer" class="dialog-footer">
        <div class="queding" @click="njshow = false">确定</div>
      </span>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="byshow" width="30%" center>
      <span>该功能不对毕业生开放！</span>
      <span slot="footer" class="dialog-footer">
        <div class="queding" @click="byshow = false">确定</div>
      </span>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="yearshow" width="30%" center>
      <span>当前年度不符合，该功能不开放！</span>
      <span slot="footer" class="dialog-footer">
        <div class="queding" @click="yearshow = false">确定</div>
      </span>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="djshow" width="30%" center>
      <span>信息未登记，请先填写学生信息登记！</span>
      <span slot="footer" class="dialog-footer">
        <div class="queding" @click="djshow = false">确定</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { getsarends } from "@/api/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      avtive: "0",
      imgpan: 0, //鼠标移入图片
      show: false, //未到开放时间
      list: [],
      njshow: false, //8年级不开放
      byshow: false, //毕业生不开放
      yearshow: false, //不符合当前年度不开放
      djshow: false, //未登记不开放
      biyesheng: "0", //1-毕业生
      year: "0", //0当前年度 1-不符合当前年度
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    switch (window.location.hash) {
      case "#/regbtn":
        this.avtive = "1";
        break;
      case "#/query":
        this.avtive = "2";
        break;
      case "#/gradesquery":
        this.avtive = "3";
        break;
      case "#/high":
        this.avtive = "4";
        break;
      case "#/admitquery":
        this.avtive = "5";
        break;
      case "#/inzhi":
        this.avtive = "6";
        break;
      case "#/inquery":
        this.avtive = "7";
        break;
      default:
        this.avtive = "0";
    }
    this.getsarend();
  },
  //方法集合
  methods: {
    tiaos(s) {
      // console.log(s);
      // console.log(this.list);
      // console.log(this.list.includes(String(s)));
      if (this.list.includes(String(s))) {
        if (this.year == "1") {
          this.yearshow = true;
        } else if (this.biyesheng == "1") {
          this.byshow = true;
        } else if (
          (s == 4 || s == 5 || s == 6 || s == 7) &&
          JSON.parse(sessionStorage.getItem("grade")) == "8"
        ) {
          this.njshow = true;
        } else if (
          (s == 3 || s == 4 || s == 5 || s == 6 || s == 7) &&
          JSON.parse(sessionStorage.getItem("userid")) == null
        ) {
          this.djshow = true;
        } else {
          this.tiao(s);
        }
      } else {
        this.show = true;
      }
    },
    //点击
    tiao(s) {
      this.avtive = s;
      if (s == "1") {
        this.$router.push({
          path: "/regbtn",
          query: {},
        });
      } else if (s == "2") {
        this.$router.push({
          path: "/query",
          query: {},
        });
      } else if (s == "3") {
        this.$router.push({
          path: "/gradesquery",
          query: {},
        });
      } else if (s == "4") {
        this.$router.push({
          path: "/high",
          query: {},
        });
      } else if (s == "5") {
        this.$router.push({
          path: "/admitquery",
          query: {},
        });
      } else if (s == "6") {
        this.$router.push({
          path: "/inzhi",
          query: {},
        });
      } else if (s == "7") {
        this.$router.push({
          path: "/inquery",
          query: {},
        });
      }
    },
    //鼠标移入
    mousein(s) {
      this.imgpan = s;
    },
    //鼠标移除
    mouseout(s) {
      this.imgpan = 0;
    },
    // 获取配置开放信息
    async getsarend() {
      // this.$loading({
      //   text: "正在加载中。。。",
      // });
      this.$tip(true, "正在加载中。。。");
      const data = await getsarends();
      console.log(data);
      // this.$loading().close();
      this.$tip(false);
      if (data.code == 200) {
        console.log(data.data);
        if (data.data && data.data.clientStatus) {
          const s = data.data.clientStatus;
          this.list = s.split(",");
          console.log(this.list);
          sessionStorage.setItem("caidan", JSON.stringify(this.list));
          this.$store.commit("SET_NIANDU", data.data.year);
          const x = String(data.data.year).slice(2);
          const y = String(
            JSON.parse(sessionStorage.getItem("login")).bmNumber
          ).slice(0, 2);
          console.log(x, y);
          if (x == y) {
            sessionStorage.setItem("grade", JSON.stringify("9"));
          } else {
            sessionStorage.setItem("grade", JSON.stringify("8"));
          }
          if (x > y) {
            this.biyesheng = "1";
          } else {
            this.biyesheng = "0";
          }
          const z = new Date().getFullYear();
          // console.log(x, z);

          //报名序号大于年度可操作
          if (x > y) {
            // this.year = "1";
            if (window.location.hash != "menu") {
              this.avtive = "0";
              this.$router.push({
                path: "/menu",
                query: {},
              });
            }
          } else {
            // this.year = "0";
          }
          //根据本地时间和年度来判断是否可以操作
          // if (Number(data.data.year) != Number(z)) {
          //   this.year = "1";
          //   if (window.location.hash != "menu") {
          //     this.avtive = "0";
          //     this.$router.push({
          //       path: "/menu",
          //       query: {},
          //     });
          //   }
          // } else {
          //   this.year = "0";
          // }
        } else {
          this.$message.error("未到报名开始时间");
          // this.$tip(true, "未到报名开始时间。。");
        }
      } else {
        this.$message.error(data.msg);
      }
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.centers {
  display: flex;
  background-color: #fff;
  .divs {
    width: 100%;
    cursor: pointer;
    padding: 00.6rem 0rem;
    display: flex;
    justify-content: center;
    img {
      width: 1.2rem;
      height: 1.2rem;
      margin-right: 0.5rem;
    }
  }
  .divs:hover {
    background-color: #2d9167;
    color: #fff;
  }
  // div {
  //   padding: 00.6rem 0rem;
  //   display: flex;
  //   justify-content: center;
  // }
}
.green {
  color: #2d9167;
  padding: 00.6rem 0rem;
  display: flex;
  justify-content: center;
  font-weight: bold;
}
.bgcolor {
  width: 100%;
  background-color: #2d9167;
  color: #fff;
}

.queding {
  width: 5rem;
  height: 2rem;
  background-color: #2c9167;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  cursor: pointer;
}
/deep/.el-dialog {
  // height: 15rem;
}
/deep/.el-dialog__header {
  background-color: #2c9167;
  padding: 0.8rem 0.8rem;
}
/deep/.el-dialog__title {
  line-height: 0.96rem;
  font-size: 0.8rem;
  color: #ffffff;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
/deep/.el-dialog__headerbtn {
  top: 1rem;
  right: 1rem;
  font-size: 0.88rem;
}
/deep/.el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 2rem 1rem;
  font-size: 1rem;
}
/deep/.el-dialog--center .el-dialog__footer {
  text-align: center;
  display: flex;
  justify-content: center;
}
.dialog-footer {
  display: flex;
  align-items: center;
}
</style>